
import { axios } from '@/utils/requestC'

const Capi = {
  Login: '/5f0972e84e26c',
  LogoutCai:'/auth/logout'

}
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function Clogin (parameter) {
  return axios({
    url: Capi.Login,
    method: 'post',
    data: parameter
  })
}
export function LogoutC () {
  return axios({
    url: Capi.LogoutCai,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
